import type { BrowserOptions, EdgeOptions, NodeOptions } from '@sentry/nextjs';

// @sentry/nextjs 는 SamplingContext 타입을 재export 하지 않으므로 옵션 타입에서 끌어온다.
type TracesSampler = NonNullable<NodeOptions['tracesSampler']>;

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const environment = process.env.NEXT_PUBLIC_PHASE ?? process.env.PHASE;
const release = process.env.NEXT_PUBLIC_SENTRY_RELEASE;

export const isSentryEnabled =
  process.env.NODE_ENV === 'production' && Boolean(dsn);

// 트레이싱(Performance Units)은 production phase 에서만 수집한다.
// dev/sandbox 도 프로덕션 빌드로 돌기 때문에 NODE_ENV 로는 구분되지 않는다.
// 에러 수집은 phase 와 무관하게 그대로 유지된다.
const tracesSampleRate = environment === 'production' ? 0.1 : 0;

const tracesSampler: TracesSampler = ({ name, inheritOrSampleWith }) => {
  // proxy.ts(구 middleware) 트랜잭션은 페이지 렌더 트랜잭션과 별개로 생성되어
  // Performance Units 소비의 약 83% 를 차지하므로 수집하지 않는다.
  // 프록시 구간 지연은 페이지 트랜잭션의 자식 스팬으로 여전히 관측 가능하다.
  if (name.startsWith('middleware ')) return 0;

  // 상위 트레이스의 샘플링 결정을 이어받는다. 이어받을 결정이 없을 때만
  // tracesSampleRate 로 판단한다 (기존 tracesSampleRate 설정과 동일한 동작).
  return inheritOrSampleWith(tracesSampleRate);
};

const baseSentryOptions = {
  dsn,
  enabled: isSentryEnabled,
  environment,
  release,
  debug: false,
  tracesSampler,
};

export const clientSentryOptions: BrowserOptions = {
  ...baseSentryOptions,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
};

export const serverSentryOptions: NodeOptions = baseSentryOptions;

export const edgeSentryOptions: EdgeOptions = baseSentryOptions;
